import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useWebHaptics } from 'web-haptics/react';
type ImpactStyle = 'light' | 'medium' | 'heavy';
type NotificationType = 'success' | 'warning' | 'error';
export function useHaptics() {
  const $ = _c(11);
  const {
    trigger,
    isSupported
  } = useWebHaptics();
  let t0;
  if ($[0] !== trigger) {
    t0 = t1 => {
      const style = t1 === undefined ? "medium" : t1;
      trigger(style);
    };
    $[0] = trigger;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const impact = t0;
  let t1;
  if ($[2] !== trigger) {
    t1 = () => {
      trigger("selection");
    };
    $[2] = trigger;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const selection = t1;
  let t2;
  if ($[4] !== trigger) {
    t2 = type => {
      trigger(type);
    };
    $[4] = trigger;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const notification = t2;
  let t3;
  if ($[6] !== impact || $[7] !== isSupported || $[8] !== notification || $[9] !== selection) {
    t3 = {
      impact,
      selection,
      notification,
      isSupported
    };
    $[6] = impact;
    $[7] = isSupported;
    $[8] = notification;
    $[9] = selection;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}